import { Component, OnDestroy, OnInit } from '@angular/core'
import { Store, select } from '@ngrx/store'
import Validator from '@shared/validatorjs/src/validator'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'
import FormTrait from 'src/app/traits/form.trait'
import {
  CreateBusinessCategoryRequest,
  SetDefaultData,
  UpdateField,
} from '../business-categories.actions'
import { getCreateBusinessCategoryState } from '../business-categories.selectors'
import { FetchLicenseTypesRequest } from '@shared/shared.actions'
import { getLicenseTypesState } from '@shared/shared.select'

@Component({
  selector: 'app-create-business-category',
  templateUrl: './create-business-category.component.html',
  styleUrls: ['./create-business-category.component.css'],
})
export class CreateBusinessCategoryComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private licenseTypes$: Subscription
  public isLoading: boolean
  public licenseTypes = []

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createBusinessCategory'))
    this.store.dispatch<any>(new FetchLicenseTypesRequest())
    this.state$ = this.store
      .pipe(select(getCreateBusinessCategoryState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.licenseTypes$ = this.store
      .pipe(select(getLicenseTypesState))
      .subscribe((state) => {
        this.licenseTypes = state.toJS()
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.licenseTypes$.unsubscribe()
  }

  public handleFieldChange(
    e: any,
    name: null | string = null,
    row: null | number = null,
  ): void {
    if (row !== null) {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name
            ? e
            : isNaN(e.target.value)
            ? e.target.value
            : parseFloat(e.target.value),
          `createBusinessCategory.data.subIndustryList.${row}`,
        ),
      )
    } else {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name ? e : e.target.value,
          'createBusinessCategory.data',
        ),
      )

      this.store.dispatch(
        new UpdateField(
          'validationErrors',
          this.state.get('validationErrors').delete(name || e.target.name),
          'createBusinessCategory',
        ),
      )
    }
  }

  public rowDelete(row: number) {
    const list = this.state.getIn(['data', 'subIndustryList']) as any

    this.store.dispatch(
      new UpdateField(
        'subIndustryList',
        list.delete(row).toJS(),
        `createBusinessCategory.data`,
      ),
    )
  }

  public rowAdd() {
    const list = this.state.getIn(['data', 'subIndustryList']) as any
    this.store.dispatch(
      new UpdateField(
        'subIndustryList',
        list.push({ name: '', industry: null }).toJS(),
        `createBusinessCategory.data`,
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
      licenseTypeId: 'required',
    }
    const validator = new Validator(
      {
        name: data.get('name'),
        licenseTypeId: data.get('licenseTypeId'),
      },
      rules,
    )

    validator.setAttributeNames({
      licenseTypeId: 'license type',
    })

    return validator
  }

  public onSubmit(e: Event, redirect = true): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new CreateBusinessCategoryRequest(
          {
            ...payload,
            penaltyPercentage: parseFloat(payload.penaltyPercentage),
          },
          redirect,
        ),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createBusinessCategory',
        ),
      )
    }
  }
}
